import { Link } from 'react-router-dom';

import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { HigherEdOrg, OrgManager } from '@uplift/api';
import { ROUTING_CONFIG } from '@uplift/constants';
import { EditableSectionContainer, EditableSectionRow } from '@uplift/ui-v2';

type ManagerOrganizationSectionProps = {
  org: HigherEdOrg;
  manager: OrgManager;
};

export const ManagerOrganizationSection: React.VFC<ManagerOrganizationSectionProps> = ({ org, manager }) => {
  const { classes } = useStyles();

  return (
    <EditableSectionContainer
      title="Organization"
      rowDividers
    >
      <EditableSectionRow
        label="Name"
        rowKey="name"
        kind="custom"
        testId="org-name-row"
      >
        <Box display="flex">
          <Box flex={1}>
            <Link to={ROUTING_CONFIG.higherEducationProfileDetails.replace(':id', org?.id ?? '')} className={classes.orgName}>
              {org.name}
            </Link>
          </Box>
        </Box>
      </EditableSectionRow>

      <EditableSectionRow
        label="Role"
        rowKey="role"
        kind="custom"
        testId="manager-role-row"
      >
        <Typography className={classes.title}>
          {manager.role}
        </Typography>
      </EditableSectionRow>
    </EditableSectionContainer>
  );
};

const useStyles = makeStyles({ name: 'ManagerOrganizationSection' })(theme => ({
  title: {
    fontWeight: 500,
    textTransform: 'capitalize',
    letterSpacing: '0.5px'
  },
  orgName: {
    fontWeight: 500,
    textDecoration: 'underline',
    letterSpacing: '0.4px',
    color: theme.palette.text.primary,
  }
}));
